import Lottie from 'lottie-react';

import bikeLoaderAnimation from '@/lotties/bike-loader.json';

const StudioLoader = () => {
  return (
    <section
      aria-label='Estado - Carregando'
      className='flex flex-col items-center justify-center w-full h-full min-h-[500px] gap-6'
      data-testid='studio-loader'
    >
      <Lottie animationData={bikeLoaderAnimation} loop autoplay className='size-72' />
    </section>
  );
};

export { StudioLoader };
